import type { FormDefinition } from '@/core/templates/types'

export default {
  title: 'Coachingnachweis',
  sections: {
    Sitzung: {
      fields: [
        { id: 'Sitzung.Datum', control: 'date' },
        { id: 'Sitzung.Beginn', control: 'text-or-date' },
        { id: 'Sitzung.Dauer in UE', control: 'select', options: ['1', '2', '3', '4'] },
        { id: 'Sitzung.Anwesenheit', control: 'select', options: ['Anwesend', 'Entschuldigt', 'Unentschuldigt', 'Krank'] },
        { id: 'Sitzung.Ort', control: 'text-or-date' },
        { id: 'Sitzung.Modul', control: 'select', options: [] },
        { id: 'Sitzung.Inhalt', control: 'text', dictation: true },
      ],
    },
  },
} satisfies FormDefinition
